import { render, staticRenderFns } from "./Steps.vue?vue&type=template&id=38620f76&"
import script from "./Steps.vue?vue&type=script&lang=js&"
export * from "./Steps.vue?vue&type=script&lang=js&"
import style0 from "./Steps.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('38620f76')) {
      api.createRecord('38620f76', component.options)
    } else {
      api.reload('38620f76', component.options)
    }
    module.hot.accept("./Steps.vue?vue&type=template&id=38620f76&", function () {
      api.rerender('38620f76', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/chile/approvals/components/trays/managementTray/informationFlow/Steps.vue"
export default component.exports